import type { ProsthesisStatus } from "@bookdental/schemas";

/** Status simplificado que o dentista vê — o laboratório trabalha com os status granulares
 *  (prosthesis-meta.ts), mas pro dentista só interessa em que fase geral o pedido está.
 *  RECUSADO (laboratório recusou antes de aceitar) é diferente de CANCELADO (aceito e cancelado
 *  depois, já em produção) — mensagens diferentes pro dentista em cada caso. */
export type DentistStatusBucket = "AGUARDANDO_CONFIRMACAO" | "RECUSADO" | "ACEITO" | "EM_PRODUCAO" | "ENTREGUE" | "CANCELADO";

const BUCKET_BY_STATUS: Record<ProsthesisStatus, DentistStatusBucket> = {
  AGUARDANDO_CONFIRMACAO: "AGUARDANDO_CONFIRMACAO",
  RECUSADO: "RECUSADO",
  ACEITO: "ACEITO",
  EM_PRODUCAO: "EM_PRODUCAO",
  CONCLUIDO: "ENTREGUE",
  CANCELADO: "CANCELADO",
};

export const DENTIST_STATUS_META: Record<DentistStatusBucket, { label: string; color: string; bg: string }> = {
  AGUARDANDO_CONFIRMACAO: { label: "Aguardando Confirmação", color: "#2457ff", bg: "#2457ff1a" },
  RECUSADO: { label: "Recusado pelo laboratório", color: "#78716c", bg: "#78716c1a" },
  ACEITO: { label: "Pedido Aceito", color: "#6d95ff", bg: "#6d95ff1a" },
  EM_PRODUCAO: { label: "Em produção", color: "#f59e0b", bg: "#f59e0b1a" },
  ENTREGUE: { label: "Entregue", color: "#22c55e", bg: "#22c55e1a" },
  CANCELADO: { label: "Cancelado", color: "#ef4444", bg: "#ef44441a" },
};

/** Os 4 status do fluxo feliz — "Cancelado" é uma exceção rara, não entra no filtro padrão. */
export const DENTIST_STATUS_ORDER: DentistStatusBucket[] = ["AGUARDANDO_CONFIRMACAO", "ACEITO", "EM_PRODUCAO", "ENTREGUE"];

export function dentistStatusBucket(status: ProsthesisStatus): DentistStatusBucket {
  return BUCKET_BY_STATUS[status];
}
